import {useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withParams} from "../../App";
import PageComponent from "../pageComponent/pageComponent";
import {usePytorchDataStore} from "../../store/pytorchDataStore";
import {getTopicPages} from "./pageDataHelpers";

// Rendered when the current slug isn't found in the data (or while data
// hasn't loaded yet) so the page still has something sensible to show
// instead of throwing on undefined fields.
const DEFAULT_ENTRY = {
    title: 'PyTorch',
    tags: [], sourceLinks: [], languages: [], algos: [], attributed: [],
    source: '', dataFile: '', download: ''
};

const DEFAULT_NEXT = {key: '', slug: '', title: 'Machine Learning', path: '/machine-learning/tutorials/pytorch/'};

// NOTE: App.js routes to the *named* export below directly (not the
// withParams-wrapped default export), so the slug is read via useParams()
// here rather than a `params` prop.
export const PytorchPage = () => {
    const {slug = ''} = useParams();

    // usePytorchDataStore fetches /data/pytorchData.json once (cached in
    // memory + localStorage) — see src/store/createDataStore.js.
    const {slugs, nextPage, relatedPages, suggestedCourses, isLoaded, loadData} = usePytorchDataStore();

    useEffect(() => {
        loadData();
    }, [loadData]);

    if (!isLoaded) {
        return <div>Loading…</div>;
    }

    const found = slugs.find(item => item.slug === slug);
    if (!found) {
        console.error('PytorchPage Failed to locate HTML path for slug : ' + slug);
    }
    const current = found || DEFAULT_ENTRY;

    const next = nextPage.find(item => item.key === slug);
    const related = relatedPages.filter(item => item.key === slug);
    const suggested = suggestedCourses.filter(item => item.key === slug);
    const topicPages = getTopicPages(slugs, current, slug);

    const state = {
        nextContent: next || DEFAULT_NEXT,
        relatedContent: related,
        topicPages,
        title: current.title,
        tags: current.tags,
        sourceLinks: current.sourceLinks,
        languages: current.languages,
        algos: current.algos ?? [],
        suggestedCourses: suggested,
        attributed: current.attributed,
        source: current.source,
        html: '',
        dataFile: current.dataFile,
        download: current.download
    };

    return (
        <PageComponent props={state} page="Pytorch Page"/>
    );
};

export default withParams(PytorchPage);
